module.exports = __webpack_public_path__ + "static/media/font_bold.d0d6e668.woff";